import { render } from "./IconAlert.vue?vue&type=template&id=6b00eaae"
import script from "./IconAlert.vue?vue&type=script&lang=js"
export * from "./IconAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icons/IconAlert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b00eaae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b00eaae', __exports__)) {
    api.reload('6b00eaae', __exports__)
  }
  
  module.hot.accept("./IconAlert.vue?vue&type=template&id=6b00eaae", () => {
    api.rerender('6b00eaae', render)
  })

}


export default __exports__